import type {
  ActivityItem,
  Contact,
  Deal,
  Pipeline,
  TaskItem,
  UserSummary,
} from "../types/crm";

export const users: Record<string, UserSummary> = {
  ak: { id: "user-ak", name: "Алексей Кузнецов", initials: "АК", tone: "violet" },
  ek: { id: "user-ek", name: "Елена Крылова", initials: "ЕК", tone: "blue" },
  ib: { id: "user-ib", name: "Иван Беляев", initials: "ИБ", tone: "green" },
  ns: { id: "user-ns", name: "Нина Соколова", initials: "НС", tone: "amber" },
};

export const pipeline: Pipeline = {
  id: "pipeline-repeat-sales",
  name: "Повторные продажи",
  stages: [
    { id: "new", name: "Новый лид", color: "blue", stageType: "open" },
    { id: "contacted", name: "Связались", color: "violet", stageType: "open" },
    { id: "proposal", name: "Предложение", color: "green", stageType: "open" },
    { id: "payment", name: "Ожидаем оплату", color: "amber", stageType: "open" },
    { id: "won", name: "Успешно реализовано", color: "green", stageType: "won" },
    { id: "lost", name: "Закрыто и не реализовано", color: "amber", stageType: "lost" },
  ],
};

export const initialDeals: Deal[] = [
  {
    id: "deal-anna-coffee",
    title: "Анна Смирнова",
    subtitle: "Повторная закупка кофе",
    amount: 45000,
    currency: "RUB",
    source: "email",
    sourceLabel: "email",
    assignee: users.ek,
    dueDate: "2026-08-28",
    stageId: "new",
    status: "open",
    contactName: "Анна Смирнова",
    phone: "+7 000 000-00-01",
    email: "anna@example.com",
    tags: ["Повторная покупка", "VIP"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-sever",
    title: "ООО Север",
    subtitle: "Расходные материалы",
    amount: 88000,
    currency: "RUB",
    source: "telegram",
    sourceLabel: "Telegram",
    assignee: users.ib,
    dueDate: "2026-08-29",
    stageId: "new",
    status: "open",
    contactName: "Ирина Белова",
    phone: "+7 000 000-00-02",
    tags: ["B2B", "Новый клиент"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-maria",
    title: "Мария Петрова",
    subtitle: "Доп. оборудование",
    amount: 40000,
    currency: "RUB",
    source: "html_form",
    sourceLabel: "форма на сайте",
    assignee: users.ak,
    dueDate: "2026-08-30",
    stageId: "new",
    status: "open",
    contactName: "Мария Петрова",
    email: "maria@example.com",
    tags: ["Входящий лид"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-sloy",
    title: "Кофейня «Слой»",
    subtitle: "Кофе и сиропы",
    amount: 84000,
    currency: "RUB",
    source: "max",
    sourceLabel: "MAX",
    assignee: users.ak,
    dueDate: "2026-08-29",
    stageId: "contacted",
    status: "open",
    contactName: "Кофейня «Слой»",
    phone: "+7 000 000-00-03",
    email: "client@example.com",
    nextPurchaseAt: "2026-09-27",
    tags: ["HoReCa", "Постоянный клиент"],
    version: 3,
    messages: [
      {
        id: "msg-1",
        direction: "inbound",
        body: "Добрый день! Интересует поставка кофе и сиропов на постоянной основе.",
        createdAt: "2026-08-27T10:14:00+05:00",
        status: "received",
      },
      {
        id: "msg-2",
        direction: "outbound",
        body: "Здравствуйте! Спасибо за обращение. Подготовлю коммерческое предложение.",
        createdAt: "2026-08-27T10:28:00+05:00",
        status: "sent",
      },
    ],
    tasks: [
      {
        id: "task-proposal",
        title: "Отправить предложение",
        dueAt: "2026-08-27T16:00:00+05:00",
        completed: false,
        assignee: users.ak,
        version: 1,
      },
    ],
  },
  {
    id: "deal-igor",
    title: "Игорь Волков",
    subtitle: "Кофе в зёрнах",
    amount: 33000,
    currency: "RUB",
    source: "manual",
    sourceLabel: "ручной ввод",
    assignee: users.ek,
    dueDate: "2026-08-30",
    stageId: "contacted",
    status: "open",
    contactName: "Игорь Волков",
    phone: "+7 000 000-00-04",
    tags: ["Розница"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-horizon",
    title: "ООО Горизонт",
    subtitle: "Упаковка",
    amount: 40000,
    currency: "RUB",
    source: "manual",
    sourceLabel: "ручной ввод",
    assignee: users.ns,
    dueDate: "2026-08-31",
    stageId: "contacted",
    status: "open",
    contactName: "Ольга Ларина",
    tags: ["B2B"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-park",
    title: "Ресторан Парк",
    subtitle: "Чай и десерты",
    amount: 120000,
    currency: "RUB",
    source: "email",
    sourceLabel: "email",
    assignee: users.ib,
    dueDate: "2026-09-01",
    stageId: "proposal",
    status: "open",
    contactName: "Ресторан Парк",
    tags: ["HoReCa", "Крупная сделка"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-alpha",
    title: "ООО Альфа",
    subtitle: "Кофемашина",
    amount: 90000,
    currency: "RUB",
    source: "webhook",
    sourceLabel: "webhook",
    assignee: users.ns,
    dueDate: "2026-09-02",
    stageId: "proposal",
    status: "open",
    contactName: "ООО Альфа",
    tags: ["Оборудование"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-bistro",
    title: "Бистро Берег",
    subtitle: "Кофе и сиропы",
    amount: 63000,
    currency: "RUB",
    source: "telegram",
    sourceLabel: "Telegram",
    assignee: users.ak,
    dueDate: "2026-09-03",
    stageId: "payment",
    status: "open",
    contactName: "Бистро Берег",
    tags: ["HoReCa"],
    version: 1,
    messages: [],
    tasks: [],
  },
  {
    id: "deal-anna-tea",
    title: "Анна Смирнова",
    subtitle: "Чайная линейка",
    amount: 80000,
    currency: "RUB",
    source: "max",
    sourceLabel: "MAX",
    assignee: users.ek,
    dueDate: "2026-09-04",
    stageId: "payment",
    status: "open",
    contactName: "Анна Смирнова",
    tags: ["Повторная покупка"],
    version: 1,
    messages: [],
    tasks: [],
  },
];

export const contacts: Contact[] = [
  { id: "c-1", name: "Анна Смирнова", company: "—", email: "anna@example.com", phone: "+7 000 000-00-01", tags: ["Повторная покупка", "VIP"], deals: 4, revenue: 214000, nextPurchaseAt: "2026-09-18", assignee: users.ek },
  { id: "c-2", name: "Ирина Белова", company: "ООО Север", email: "irina@example.com", phone: "+7 000 000-00-02", tags: ["B2B"], deals: 2, revenue: 156000, nextPurchaseAt: "2026-10-02", assignee: users.ib },
  { id: "c-3", name: "Александр Романов", company: "Кофейня «Слой»", email: "client@example.com", phone: "+7 000 000-00-03", tags: ["HoReCa", "Постоянный клиент"], deals: 5, revenue: 468000, nextPurchaseAt: "2026-09-27", assignee: users.ak },
  { id: "c-4", name: "Мария Петрова", company: "—", email: "maria@example.com", phone: "+7 000 000-00-04", tags: ["Входящий лид"], deals: 1, revenue: 40000, assignee: users.ak },
  { id: "c-5", name: "Ольга Ларина", company: "ООО Горизонт", email: "olga@example.com", phone: "+7 000 000-00-05", tags: ["B2B"], deals: 3, revenue: 126000, nextPurchaseAt: "2026-09-12", assignee: users.ns },
];

export const tasks: TaskItem[] = [
  { id: "t-1", title: "Отправить предложение", entity: "Кофейня «Слой»", dueAt: "Сегодня, 16:00", status: "today", assignee: users.ak },
  { id: "t-2", title: "Позвонить по повторному заказу", entity: "Анна Смирнова", dueAt: "Сегодня, 12:30", status: "overdue", assignee: users.ek },
  { id: "t-3", title: "Уточнить объём поставки", entity: "ООО Север", dueAt: "Завтра, 10:00", status: "upcoming", assignee: users.ib },
  { id: "t-4", title: "Проверить оплату", entity: "Бистро Берег", dueAt: "2 сентября, 11:00", status: "upcoming", assignee: users.ak },
];

export const activities: ActivityItem[] = [
  { id: "a-1", kind: "message", title: "Новое сообщение", detail: "Кофейня «Слой» написала в MAX", createdAt: "10:14", actor: users.ak },
  { id: "a-2", kind: "deal", title: "Сделка перемещена", detail: "Ресторан Парк → Предложение", createdAt: "09:48", actor: users.ib },
  { id: "a-3", kind: "task", title: "Задача выполнена", detail: "Уточнить реквизиты — ООО Альфа", createdAt: "09:22", actor: users.ns },
  { id: "a-4", kind: "contact", title: "Создан клиент", detail: "Мария Петрова из формы на сайте", createdAt: "Вчера, 18:40", actor: users.ak },
];
